import { render, staticRenderFns } from "./Input2.vue?vue&type=template&id=62c5d91f&scoped=true&"
import script from "./Input2.vue?vue&type=script&lang=js&"
export * from "./Input2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5d91f",
  null
  
)

export default component.exports